



























































import { defineComponent, ref } from "@vue/composition-api";
import PlaceModel from "@/ts/models/placeClass";
import ImageModel from "@/ts/models/imageClass";

export default defineComponent({
  name: "",

  props: {
    place: {
      type: PlaceModel,
      default: {}
    }
  },

  setup(props, { root }) {
    const placeNavItems = ref([
      {
        title: root.$options.filters!.capitalize(root.$t("calendar")),
        path: "/place/" + root.$route.params.id + "/calendar",
        icon: "event"
      },
      {
        title: root.$options.filters!.capitalize(root.$t("notes")),
        path: "/place/" + root.$route.params.id + "/notes",
        icon: "description"
      },
      {
        title: root.$options.filters!.capitalize(root.$t("projects")),
        path: "/place/" + root.$route.params.id + "/projects",
        icon: "handyman"
      },
      {
        title: root.$options.filters!.capitalize(root.$t("events")),
        path: "/place/" + root.$route.params.id + "/events",
        icon: "star"
      }
    ]);

    return {
      placeNavItems
    };
  }
});
